<div class="content-with-stepper-and-title finger-prints-scan">
  <div class="row">
    <div class="col-4 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div class="title">
        <h1 id="fingerPrintsTitle" [innerHTML]="copyService.copies.finger_prints_title"></h1>
      </div>

      <div id="fingerPrintsSubtitle" class="subtitle" [innerHTML]="copyService.copies.finger_prints_subtitle">
      </div>

      <div class="animation">
        <lottie-animation-view id="fingerPrintsAnimation" class="image" [options]="image" [width]="200"></lottie-animation-view>
      </div>
    </div>
  </div>
  <app-controls id="fingerPrintsBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.finger_prints_btn" (next)="next()"></app-controls>
</div>
